<template>
  <figure>
    <img
      @contextmenu.prevent="preventRightClick"
      class="image-element"
      :class="[
        displayClass,
        {'image-element--mod-not-draggable': !draggable}
      ]"
      :src="imgSrc"
      :alt="altText"
      :draggable="draggable"
    />
  </figure>
</template>
<script>
import getTypeClass from '../../utils/getTypeClass'
export default {
  name: 'ImageElement',
  props: {
    isIntersected: Boolean,
    draggable: Boolean,
    imageSrc: String,
    displayType: {
      type: String,
      default: 'cover'
    },
    altText: String
  },
  computed: {
    displayClass () {
      return `image-element${getTypeClass(this.displayType)}`
    },
    imgSrc: function () {
      return this.isIntersected ? this.imageSrc : null
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './image-element.scss'
</style>



// WEBPACK FOOTER //
// src/modules/ModuleImage/components/ImageElement/ImageElement.vue